import CalculatorOptions from "./CalculatorOptions";
import {isEmpty} from "lodash";
import VisibilityStorage from "./VisibilityStorage";

export default {

  get store() {
    return Spruce.store('configurator')
  },

  errors: [],

  run() {
    this.resetErrors()

    for (const option in CalculatorOptions) {
      if ((this.isNullable(option) === false) && isEmpty(CalculatorOptions[option])) {
        this.errors.push(option)
      }
    }

    return this.errors
  },

  isNullable(key) {
    if (!this.store.isInputVisible(key))
      return true

    if (this.nullable('all', key))
      return true

    return !!this.nullable(this.store.calculationMethod, key);
  },

  stringToBoolean(string) {
    return string === 'false' ||
    string === 'undefined' ||
    string === 'null' ||
    string === '0' ? false : !!string
  },

  resetErrors() {
    this.errors = []
  },

  nullable(category, key) {
    return this.stringToBoolean(VisibilityStorage.isNullable(category, key))
  }

}
